import { type ConfluenceBlueprintPage } from '../../state/confluence/types';
import { fetchJson } from '../utils';

const IGNORE_MAU_HEADER = 'x-atlassian-mau-ignore';
const EP_ENITITY_ID_HEADER = 'X-Atl-EmbeddablePage-EntityIDs';

export const createConfluenceDraft = ({
	templateId,
	projectSpaceKey,
	projectPageLinkedId,
	isEmbeddedPage,
	pageTitle,
	projectId,
	projectType,
}: {
	templateId: string;
	projectSpaceKey: string;
	projectPageLinkedId: string | null;
	isEmbeddedPage: boolean;
	pageTitle?: string;
	projectId?: number;
	projectType?: string;
}) =>
	fetchJson<ConfluenceBlueprintPage>(
		`/wiki/rest/create-dialog/1.0/content/blueprint/${templateId}/instance`,
		{
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				[IGNORE_MAU_HEADER]: 'true',
				[EP_ENITITY_ID_HEADER]: JSON.stringify({
					projectId,
					projectType,
				}),
			},
			body: JSON.stringify({
				content: {
					type: 'page',
					status: 'draft',
					space: { key: projectSpaceKey },
					...(projectPageLinkedId && {
						ancestors: [{ id: projectPageLinkedId }],
					}),
					title: pageTitle,
					...(isEmbeddedPage && {
						metadata: {
							frontend: {
								embedded: true,
							},
						},
					}),
				},
				contentBlueprintSpec: {
					context: {},
					blueprintId: templateId,
				},
			}),
		},
	);
